import DeclaracaoSaudePendencias from './DeclaracaoSaudePendencias';

export default DeclaracaoSaudePendencias;
